import { useDrawer } from 'contexts/DrawerContext';

/* marketplace */
import { NewQuoteSet } from 'drawers/marketplace/NewQuoteSet';
import { NewQuote } from 'drawers/marketplace/NewQuote';
import { EditQuote } from 'drawers/marketplace/EditQuote';
import { AddQuoteProduct } from 'drawers/marketplace/AddQuoteProduct';
import { SaveQuote } from 'drawers/marketplace/SaveQuote';
import { LoadQuote } from 'drawers/marketplace/LoadQuote';
import { QuoteDetails } from 'drawers/marketplace/QuoteDetails';
import { QuoteProductDetails } from 'drawers/marketplace/QuoteProductDetails';
import { SendPurchaseOrder } from 'drawers/marketplace/SendPurchaseOrder';
import { ShareQuoteSet } from 'drawers/marketplace/ShareQuoteSet';
import { GenerateQuote } from 'drawers/marketplace/GenerateQuote';
import { EditQuoteSet } from 'drawers/marketplace/EditQuoteSet';

export const useMarketplaceDrawers = () => {
  const { openDrawer } = useDrawer();

  /* marketplace */
  const openDrawerNewQuoteSet = () => {
    openDrawer({ component: NewQuoteSet });
  };
  const openDrawerNewQuote = () => {
    openDrawer({ component: NewQuote });
  };
  const openDrawerEditQuote = () => {
    openDrawer({ component: EditQuote });
  };
  const openDrawerEditQuoteSet = () => {
    openDrawer({ component: EditQuoteSet });
  };
  const openDrawerAddQuoteProduct = () => {
    openDrawer({ component: AddQuoteProduct });
  };
  const openDrawerSaveQuote = () => {
    openDrawer({ component: SaveQuote });
  };
  const openDrawerLoadQuote = () => {
    openDrawer({ component: LoadQuote });
  };
  const openDrawerQuoteDetails = () => {
    openDrawer({ component: QuoteDetails });
  };
  const openDrawerQuoteProductDetails = () => {
    openDrawer({ component: QuoteProductDetails });
  };
  const openDrawerSendPurchaseOrder = () => {
    openDrawer({ component: SendPurchaseOrder });
  };
  const openDrawerShareQuoteSet = () => {
    openDrawer({ component: ShareQuoteSet });
  };
  const openDrawerGenerateQuote = () => {
    openDrawer({ component: GenerateQuote });
  };

  return {
    /* marketplace */
    openDrawerNewQuoteSet,
    openDrawerNewQuote,
    openDrawerEditQuote,
    openDrawerEditQuoteSet,
    openDrawerAddQuoteProduct,
    openDrawerSaveQuote,
    openDrawerLoadQuote,
    openDrawerQuoteDetails,
    openDrawerQuoteProductDetails,
    openDrawerSendPurchaseOrder,
    openDrawerShareQuoteSet,
    openDrawerGenerateQuote,
  };
};
